import { Injectable } from '@angular/core';
import { LocalStorageService } from './localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  constructor(private _localStorage: LocalStorageService) {}

  setTimeZone(zone: string) {
    return this._localStorage.set('time_zone', zone);
  }

  getTimezone() {
    return this._localStorage.get('time_zone');
  }
}
